// extracted by mini-css-extract-plugin
module.exports = {"root":"EcotrapPage_root__D_N8G"};